export class ReponseModel {

	isRequestOk: boolean;
	isErreur: boolean;

	constructor(isRequestOk:boolean, isErreur: boolean) {
		this.isRequestOk = isRequestOk;
		this.isErreur = isErreur;
	}
}
